import { Pipe, PipeTransform } from '@angular/core';
import { MenuCategory, MenuCategoryWithSubItems } from '@shared/models';

@Pipe({ name: 'menuHasSubItems', standalone: true })
export class MenuHasSubItemsPipe implements PipeTransform {
  transform(value: MenuCategory): value is MenuCategoryWithSubItems {
    return 'subItems' in value;
  }
}
